module.exports = __webpack_public_path__ + "img/img2.7a51ca4b.png";